import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';
import SEO from '../components/SEO';
import WhatsAppFloat from '../components/WhatsAppFloat';
import { blogPosts } from '../data/blogData';

const BlogList = () => {
    useEffect(() => {
        const spinner = document.getElementById('spinner');
        if (spinner) {
            spinner.classList.remove('show');
            spinner.style.display = 'none';
        }
        if (window.WOW) {
            new window.WOW().init();
        }
        window.scrollTo(0, 0);
    }, []);

    const schema = {
        "@context": "https://schema.org",
        "@type": "Blog",
        "name": "WebBears Digital Insights Blog",
        "url": "https://webbears.com/blog",
        "description": "Expert insights on website development, eCommerce costs, and digital marketing strategies focusing on Bhiwandi, Thane, and Mumbai regions."
    };

    return (
        <>
            <SEO 
                title="WebBears Blog | Expert Web Development & Marketing Insights"
                description="Read our latest insights on website development costs, eCommerce platforms, and dominating local SEO in Bhiwandi and Mumbai."
                keywords="web development blog, ecommerce cost guide, digital marketing tips, local seo strategies"
                url="https://webbears.com/blog"
                schemaMarkup={schema}
            />
            <WhatsAppFloat />
            <Navbar />

            {/* Page Header Start */}
            <div className="container-fluid page-header mb-5">
                <div className="container mt-5 pt-5 text-center">
                    <h1 className="display-4 animated slideInDown">Digital Insights & Strategy Blog</h1>
                    <nav aria-label="breadcrumb animated slideInDown">
                        <ol className="breadcrumb justify-content-center mb-0">
                            <li className="breadcrumb-item"><Link to="/">Home</Link></li>
                            <li className="breadcrumb-item active" aria-current="page">Blog</li>
                        </ol>
                    </nav>
                </div>
            </div>
            {/* Page Header End */}

            <div className="container-xxl py-5">
                <div className="container">
                    <div className="text-center mx-auto wow fadeInUp" data-wow-delay="0.1s" style={{ maxWidth: '600px' }}>
                        <p className="d-inline-block border rounded text-primary fw-semi-bold py-1 px-3">Latest Articles</p>
                        <h2 className="display-5 mb-5">Master the Online Business Jungle</h2>
                    </div>

                    <div className="row g-4">
                        {blogPosts.map((post, index) => (
                            <div className="col-lg-4 col-md-6 wow fadeInUp" data-wow-delay={`${0.1 + (index * 0.2)}s`} key={post.slug}>
                                <div className="bg-light rounded h-100 d-flex flex-column shadow-sm overflow-hidden border">
                                    <img src={post.image} alt={post.title} className="img-fluid w-100" style={{ height: '250px', objectFit: 'cover' }} />
                                    <div className="p-4 d-flex flex-column flex-grow-1">
                                        <div className="mb-2 text-muted small d-flex justify-content-between">
                                            <span><i className="far fa-calendar-alt text-primary me-2"></i>{new Date(post.date).toLocaleDateString()}</span>
                                            <span>{post.author}</span>
                                        </div>
                                        <h3 className="h5 mb-3">
                                            <Link to={`/blog/${post.slug}`} className="text-dark text-decoration-none">{post.title}</Link>
                                        </h3>
                                        <p className="mb-4 flex-grow-1">{post.description}</p>
                                        <Link to={`/blog/${post.slug}`} className="btn btn-outline-primary mt-auto">Read Full Article <i className="fa fa-arrow-right ms-2"></i></Link>
                                    </div>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </div>

            <Footer />
        </>
    );
};

export default BlogList;
